import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59455b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modules" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}
const _hoisted_3 = {
  key: 1,
  class: "lds-ring"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  id: "container",
  class: "col-12"
}
const _hoisted_10 = {
  key: 0,
  id: "module-container-wrapper",
  class: "row"
}
const _hoisted_11 = {
  key: 1,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}
const _hoisted_12 = {
  key: 2,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Module = _resolveComponent("Module")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.treatmentSet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (mod) => {
              return (_openBlock(), _createBlock(_component_Module, {
                key: mod.id,
                module: mod,
                userLanguage: _ctx.user.language
              }, null, 8, ["module", "userLanguage"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.treatmentSet && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.treatmentSet && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}